<template>
  <div>
    <el-dialog  width="900px" :close-on-click-modal="false" :visible.sync="dialogVisible" :title="title">
      <el-form style="width: 95%;margin: 0 auto" :model="form" label-position="right" label-width="140px">
        <el-form-item :label="pptName" class="pptContent">

          <div @click="onPptTplClick(item)" v-for="item in tplList" :key="item.id">
            <img :src="selectTpl.id == item.id ? item.activeImageUrl : item.imageUrl" />
          </div>
        </el-form-item>
        <el-form-item label="标题内容:" class="pptContent">
          <el-input v-model="form.title" placeholder="请输入" style="width: 642px"></el-input>
        </el-form-item>
        <el-form-item label="插入图片:" class="pptImg">
          <div>
            <div class="in-img-con">
              <div v-if="type == 1" class="add" @click="addImages">
                <i slot="default" class="el-icon-plus"></i>
              </div>
              <div v-else class="upload-img">
                <el-upload action="/" accept="image/*" multiple :http-request="uploadRequest" :show-file-list="false">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div v-for="item in selectedImages" :key="'sel-img' - item.id">
                <el-image :src="item.url" style="width:64px;height: 64px;" fit="cover"></el-image>
                <div v-if="type != 1" class="del-img" @click="onImageDel(item)">
                  <i style="font-size: 24px;" class="el-icon-circle-close"></i>
                </div>
              </div>
            </div>
            <p class="text">插入的图片数量与模板有关，如：第1个模板可以插入1张，以此类推。</p>
          </div>
        </el-form-item>
        <el-form-item v-if="type == 0" label="插入文字:" style="display: flex">
          <el-input type="textarea" placeholder="请输入" style="width: 642px;margin-left: 12px" v-model="form.content">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button :loading="addPageLoading" type="primary" @click="onAddPageConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog  :close-on-click-modal="false" :visible.sync="imageDialog" title="添加图片">
      <div>
        <el-row>
          <el-col :span="6">
            <el-menu :default-active="currentModuleId" :default-openeds="defOpens">
              <menu-tree @menuclick="onMenuClick" :data="imgTree"></menu-tree>
            </el-menu>
          </el-col>
          <el-col :span="14">
            <div class="image-con">
              <div class="filter">
                <el-row>
                  <el-col :span="12">
                    <span style=" min-width: 100px; display: inline-block; font-size:16px;font-weight: bold;">{{
                      currentModuleName }}</span>
                  </el-col>
                  <el-col :span="12">
                    <input type="text" placeholder="输入关键字">
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">

                    <div class="tag-con">
                      <div class="label">推荐标签：</div>
                      <div class="tags" :class="['tags', { open: tagsOpen }]">
                        <span :class="{ active: selectTags.indexOf(tag.id) > -1 }" v-for="(tag, index) in taglist"
                          :key="index" @click="handleSelectTag(tag.id)">
                          {{ tag.tagsName }}
                        </span>
                      </div>
                      <div class="option">
                        <span @click="handleOpenTags">
                          <template v-if="!tagsOpen">
                            <i class="el-icon-arrow-down"></i>
                          </template>
                          <template v-else>
                            <i class="el-icon-arrow-up"></i>
                          </template>
                        </span>
                      </div>
                    </div>

                  </el-col>
                </el-row>
              </div>
              <el-scrollbar v-loading="loading" class="list-con">
                <div class="list">
                  <div :class="['item', { 'select': selectImageList.findIndex(obj => obj.id == item.id) > -1 }]"
                    @click="onImageClick(item)" v-for="item in imageList" :key="item.id">
                    <el-image fit="cover" style="height: 97px; width: 100%;border-radius: 4px;" :src="item.url">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    <div class="name">{{ item.image.name }}</div>
                  </div>
                  <div class="no-data" v-if="!loading && imageList.length == 0">暂无数据</div>
                </div>
              </el-scrollbar>

            </div>
          </el-col>
          <el-col :span="4">
            <div class="select-con">

              <div class="title">已选图片</div>

              <el-scrollbar class="list">
                <div class="item" v-for="item in selectImageList" :key="item.id">
                  <el-image fit="cover" style="height: 52px; width: 84px;border-radius: 4px;" :src="item.url"></el-image>
                  <div class="name">{{ item.image.name }}</div>
                  <div class="del" @click="onDeleteImage(item)">×</div>
                </div>
              </el-scrollbar>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imageDialog = false">取 消</el-button>
        <el-button type="primary" @click="onSelectImageConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MenuTree from '@/components/pc/Menutree'
export default {
  name: "CustomPage",
  components: {
    MenuTree
  },
  props: {
    taskId: {
      type: String
    },
    fileType:{
      type:Number
    }
  },
  computed:{
    pptName(){
      let result=''
      if (this.fileType==0) {
        result="选择PPT模板:"
      }
      if (this.fileType==1) {
        result="选择WORD模板:"
      }
      return result
    }
  },
  data() {
    return {
      title: '',
      type: 1,
      selectTpl: { id: null },
      dialogVisible: false,
      tplList: [],
      form: {
        title: "", //标题
        content: ""
      },
      loading: false,
      addPageLoading:false,
      imageDialog: false,
      imgTree: [],
      selectTags: [],
      currentModuleId: '',
      currentModuleName: '',
      defOpens: [],
      tagsOpen: false,
      taglist: [],
      imageList: [],
      selectedImages: [],//最后选择的
      selectImageList: [],
      imageQuery: {
        taskId: null,
        moduleId: null,
        tagIds: [],
        pageIndex: 1,
        pageSize: 10,
      }

    }
  },
  methods: {
    onAddPageConfirm() {

      if (this.selectTpl.id == null) {
        this.$message.warning('请选择模版')
        return
      }

      if (this.form.title.length == 0) {
        this.$message.warning('请输入标题内容')
        return
      }

      if (this.selectedImages.length == 0) {
        this.$message.warning('请选择插入图片')
        return
      }

      if (this.type == 0 && this.form.content.length == 0) {
        this.$message.warning('请输插入文字')
        return
      }
      if (this.type == 0 && this.selectedImages.length > this.selectTpl.imageCount) {
        this.$message.warning(`该模版图片不能超过[${this.selectTpl.imageCount}]张`)
        return
      }
      if (this.type === 0) {
        const formdata = new FormData();
        formdata.append("title",this.form.title)
        formdata.append("templateId",this.selectTpl.id)
        formdata.append("taskId",this.taskId)
        formdata.append("content",this.form.content)
        this.selectedImages.forEach(item => {
          formdata.append("files",item.file)
        })
        this.addPageLoading = true
        this.$notify.info("生成项目介绍中请稍等")
        this.$request.saveProjectIntro(formdata).then(res => {
          res.data.selected = false
          this.$emit("confirm",res.data,this.type)
          this.dialogVisible = false
          this.$notify.success("生成项目介绍成功")
        }).finally(_ =>{
          this.addPageLoading = false
        })
      } else if (this.type === 1) {
        this.$notify.info("生成自定义页中请稍等")
        const data = {
          title: this.form.title, //标题
          templateId: this.selectTpl.id, //模板id
          imageItemIds: this.type === 0 ? '': this.selectedImages.map(item => item.id),
          taskId: this.taskId,
        }
        this.addPageLoading = true
        this.$request.saveCustomPage(data).then(res => {
          res.data.selected = false
          this.$emit("confirm",res.data,this.type)
          this.dialogVisible = false
          this.$notify.success("生成项目介绍成功")
        }).finally( _ => {
          this.addPageLoading = false
        })
      }
    },
    dataList(list) {
      list.forEach(item => {
        if (item.children && item.children.length) {
          const childIds = this.dataList(item.children)
          item.moduleName = item.name
          item.moduleId = item.id
        } else {
          item.moduleName = item.name
          item.moduleId = item.id
        }
      })
      return list
    },
    getPptImg() {
      this.$request.pptImg(this.type,this.fileType).then((res) => {
        console.log(res.data)
        this.tplList = res.data
      })
    },
    onImageClick(item) {
      let index = this.selectImageList.findIndex(obj => obj.id == item.id)
      if (this.selectImageList.length >= this.selectTpl.imageCount) {
        this.$message.warning(`该模版图片不能超过[${this.selectTpl.imageCount}]张`)
        return
      }
      if (index < 0) {
        this.selectImageList.push(item)
      }

    },
    onSelectImageConfirm() {
      this.selectedImages = this.selectImageList.map(item => item)
      this.imageDialog = false
    },
    handleOpenTags() {
      this.tagsOpen = !this.tagsOpen
    },

    handleSelectTag(tagId) {
      console.log(tagId)
      let index = this.selectTags.findIndex((item) => item == tagId)
      if (index > -1) {
        this.selectTags.splice(index, 1)
      } else {
        this.selectTags.push(tagId)
      }
      this.getImages()
    },
    onPptTplClick(tpl) {
      console.log(tpl);
      this.selectImageList = []
      this.imageList = []
      this.selectTpl = tpl
    },
    onDeleteImage(item) {
      let index = this.selectImageList.findIndex(obj => obj.id == item.id)
      this.selectImageList.splice(index, 1)
    },
    addImages() {
      //判断

      // this.selectImageList = []
      if (this.selectTpl.id == null) {
        this.$message.warning('请先选择PPT模版')
        return
      }
      // this.form.title = ''
      // this.form.content = ''
      this.taglist = []
      this.selectTags = []
      this.imageList = []

      this.imageDialog = true
      this.$request.imgTree().then((res) => {
        console.log(res, 'ingTree')

        if (res.code == 200) {
          this.imgTree = this.dataList(res.data)
          // this.currentModuleId = `${res.data[0].id}`
          this.getImageTags()
        }
      })
    },
    onMenuClick(obj) {
      console.log(obj, '选择了')

      let moduleId = obj.moduleId
      this.currentModuleId = `${moduleId}`
      this.currentModuleName = obj.moduleName
      // this.sourceFilter.keyWord = ''
      this.keyWord = ''
      this.selectTags = []
      // this.sourceFilter.moduleIds = [moduleId] // [item.moduleId]
      // // this.sourceFilter.pageNum = 1
      // this.tagsOpen = false;
      // // this.getRecommendTags(moduleId)
      // this.getSourceList()
      this.getImageTags()
    },
    uploadRequest(e) {
      let objectURL = this.getObjectURL(e.file);
      this.selectedImages.push({
        id: this.selectedImages.length + 1,
        url: objectURL,
        file: e.file
      })
    },
    onImageDel(item) {

      let index = this.selectedImages.findIndex(obj => obj.id == item.id)

      this.selectedImages.splice(index, 1)
    },
    onTagClick(e) {
      this.imageQuery.pageIndex = 1
      this.getImages()
    },
    getImageTags() {
      this.$request.getCustomPageImageTags(this.currentModuleId, this.taskId).then(res => {
        console.log(res, '标签');
        if (res.code == 200) {
          this.taglist = res.data.records
          this.getImages()
        }

      })
    },
    init(type) {
      this.type = type
      this.selectTpl = { id: null }
      this.form.title = ''
      this.form.content = ''
      this.selectImageList = []
      this.selectedImages = []
      if (type == 1) {
        this.title = '添加自定义页'
      } else {
        this.title = '添加项目介绍'
      }

      this.getPptImg()
      this.dialogVisible = true
    },
    getImages() {

      this.loading = true
      this.imageQuery.taskId = parseInt(this.taskId)
      this.imageQuery.moduleId = parseInt(this.currentModuleId)
      this.imageQuery.tagIds = []
      this.$request.getCustomPageImages(this.imageQuery).then(res => {
        console.log(res, '图片标签')
        if (res.code == 200) {
          this.imageList = res.data.records
        }
      }).finally(_ => {

        this.loading = false
      })
    },
    getObjectURL(file) {
      var url = null ;
      if (window.createObjectURL!=undefined) {
        url = window.createObjectURL(file) ;
      } else if (window.URL!=undefined) {
        url = window.URL.createObjectURL(file) ;
      } else if (window.webkitURL!=undefined) {
        url = window.webkitURL.createObjectURL(file) ;
      }
      return url ;
  }
}
}
</script>

<style scoped lang="less">
::v-deep .el-dialog {
  border-radius: 10px;
}

::v-deep .el-dialog__header {
  line-height: 60px;
  border-bottom: 1px solid #F5F5F5;
  padding-left: 32px;
  font-weight: 500;
  padding: 0px;
  padding-left: 32px;
  padding-top: 12px;
}

::v-deep .el-menu {
  border-right: 0;
}

::v-deep .el-form-item__content {
  margin-left: 0px !important;
}

::v-deep .el-dialog__body {
  padding-top: 0;
}

.pptContent {
  display: flex;

  &> ::v-deep .el-form-item__content {
    display: flex;
    margin-left: 0px !important;
  }

  div {
    margin-left: 12px;
    cursor: pointer;
  }
}

.pptImg {
  display: flex;

  & .in-img-con {
    display: flex;
    flex-wrap: wrap;

    &>div {
      flex: 0 0 64px;
      height: 64px;
      text-align: center;
      line-height: 64px;
      margin-left: 12px;
      position: relative;

      &.add {
        border: 1px solid #f5f5f5;
        border-radius: 8px;
        cursor: pointer;
      }

      &.upload-img {
        border: 1px solid #f5f5f5;
        border-radius: 8px;
        cursor: pointer;

        ::v-deep .el-upload--text {
          width: 100%;
        }
      }

      &>.del-img {
        position: absolute;
        width: 24px;
        height: 24px;
        top: -12px;
        right: -12px;
        line-height: 24px;
        cursor: pointer;

        &>i {
          color: red;
        }
      }
    }
  }

  .text {
    margin-left: 12px;
    color: rgba(0, 0, 0, 0.4);
  }
}

.tag-con {
  display: flex;
  padding-top: 16px;

  &>.label {
    margin-top: 4px;
    flex: 0 0 auto;
    font-size: 12px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
  }

  &>.tags {
    flex: 1;
    height: 26px;
    overflow: hidden;

    &>span {
      margin: 0 8px 8px 8px;
      display: inline-block;
      padding: 0 8px;
      background-color: #f5f5f5;
      border-radius: 2px;
      color: rgba(0, 0, 0, 0.85);
      height: 24px;
      line-height: 24px;
      cursor: pointer;
      font-size: 12px;

      &:hover {
        background: #e60027;
        color: #fff;
      }

      &.active {
        background: #e60027;
        color: #fff;
      }
    }

    &.open {
      height: auto;
      overflow: auto;
    }
  }

  &>.option {
    flex: 0 0 auto;
    padding: 5px;

    &>span {
      cursor: pointer;
    }
  }
}

.image-con {
  padding: 20px;
  padding-top: 0;
  height: 500px;
  border-left: 1px solid #F5F5F5;
  border-right: 1px solid #F5F5F5;
  display: flex;
  flex-direction: column;

  &>.filter {
    flex: 0 0 auto;
    padding-block: 20px;
  }

  &>.list-con {
    flex: 1;
    height: 100px;
    overflow-x: hidden !important;

    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden !important;
    }

    & .list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      &>.item {
        flex: 0 0 156px;
        position: relative;
        cursor: pointer;

        &::after {
          content: '';
          border-radius: 2px;
          position: absolute;
          right: 6px;
          top: 6px;
          width: 16px;
          height: 16px;
          background: rgba(0, 0, 0, 0.85);

          // &::after {
          //   content: '✔';
          //   color: #fff;
          //   font-size: 12px;
          // }
        }

        &.select {

          &::after {
            content: '✔';
            background: #E60027;
            color: #fff;
            font-size: 12px;
            text-align: center;

          }
        }


        &:nth-child(3n+3) {
          margin-right: 0;
        }
      }
    }
  }
}

.select-con {
  padding: 20px;

  &>.title {
    font-weight: bold;
    font-size: 16px;
  }

  &>.list {
    height: 400px;
    overflow-x: hidden !important;

    ::v-deep .el-scrollbar__wrap {
      overflow-x: hidden !important;
      padding-top: 10px;
    }


    & .item {
      margin-bottom: 16px;
      position: relative;
      width: 84px;

      &>.name {
        font-size: 12px;
        padding-top: 12px;
      }

      &>.del {
        position: absolute;
        right: -7px;
        top: -7px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.85);
        color: #fff;
        text-align: center;
        line-height: 14px;
        cursor: pointer;
      }
    }
  }
}

.no-data {
  text-align: center;
  padding-top: 40px;
  width: 100%;
  color: #ccc;
}
</style>
